import $ from 'jquery';
import copy from '@data/0-default';

/**
 * month() renders the current date name in a html element with class 'js-month'
 */
const month = () => {
  const element = $('.js-month');
  if (element.length === 0) return;
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentMonthName = copy.monthNames[currentMonth];
  element.text(currentMonthName);
};

export default month;
